import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { getWorkerReports, updateWorkerReportsPagination } from '../../../store/actions/reports/reports_action';
import { Paper, makeStyles, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import TablePagination from '../../ui_components/table_pagination';
import { roundNumber } from '../../../utils/helper_functions';
import { getWorkerReportsColor } from '../../../theme/colors';

const useStyles = makeStyles((theme) => ({
	paper: {
        width: '100%',
        marginTop: theme.spacing(3),
        overflowX: 'auto'
    },
    table: {
        minWidth: 500,
        // whiteSpace: 'noWrap'
		"& th, & td": {
			padding: '8px',
			fontSize: '12px'
		}
    },
    tableRow: {
        cursor: 'pointer'
    }
}));

const WorkerReportsTable = ({ workerReports: { collection, totalCount, page, rowsPerPage, filters }, type }) => {
    const { paper, table, tableRow } = useStyles();
    const dispatch = useDispatch();

    useEffect(() => {
        if (!collection.length) {
            dispatch(getWorkerReports({ page, rowsPerPage, filters }));
        }
    }, []);
    
    return (
			<Paper className={paper}>
				<Table aria-label="table" className={table}>
					<TableHead>
						<TableRow>
                            {type === 1 &&
                                <TableCell>Doktor</TableCell>
                            }
                            {type === 2 &&
                                <TableCell>Tehničar</TableCell>
                            }
                            {type === 3 &&
                                <TableCell>Osiguravajuća kuća</TableCell>
                            }
                            <TableCell>Januar</TableCell>
							<TableCell>Februar</TableCell>
							<TableCell>Mart</TableCell>
							<TableCell>April</TableCell>
							<TableCell>Maj</TableCell>
							<TableCell>Jun</TableCell>
							<TableCell>Jul</TableCell>
							<TableCell>Avgust</TableCell>
							<TableCell>Septembar</TableCell>
							<TableCell>Oktobar</TableCell>
							<TableCell>Novembar</TableCell>
							<TableCell>Decembar</TableCell>
							<TableCell align="right">Ukupan iznos</TableCell>
						</TableRow>
					</TableHead>
                    <TableHead>
                            {!type || type === 1 &&
                            <TableRow>
                                <TableCell>Prihod</TableCell>
                                <TableCell>doktora / kompanije</TableCell>
								<TableCell>doktora / kompanije</TableCell>
								<TableCell>doktora / kompanije</TableCell>
								<TableCell>doktora / kompanije</TableCell>
								<TableCell>doktora / kompanije</TableCell>
								<TableCell>doktora / kompanije</TableCell>
								<TableCell>doktora / kompanije</TableCell>
								<TableCell>doktora / kompanije</TableCell>
								<TableCell>doktora / kompanije</TableCell>
								<TableCell>doktora / kompanije</TableCell>
								<TableCell>doktora / kompanije</TableCell>
								<TableCell>doktora / kompanije</TableCell>
                                <TableCell align="right">Ukupni prihodi</TableCell>
                            </TableRow>                           
                            }
                            {type === 2 &&
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell>Prihod tehničara / prihod kompanije</TableCell>
                                <TableCell>Prihod tehničara / prihod kompanije</TableCell>
                                <TableCell>Prihod tehničara / prihod kompanije</TableCell>
                                <TableCell>Prihod tehničara / prihod kompanije</TableCell>
                                <TableCell>Prihod tehničara / prihod kompanije</TableCell>
                                <TableCell>Prihod tehničara / prihod kompanije</TableCell>
                                <TableCell>Prihod tehničara / prihod kompanije</TableCell>
                                <TableCell>Prihod tehničara / prihod kompanije</TableCell>
                                <TableCell>Prihod tehničara / prihod kompanije</TableCell>
                                <TableCell>Prihod tehničara / prihod kompanije</TableCell>
                                <TableCell>Prihod tehničara / prihod kompanije</TableCell>
                                <TableCell>Prihod tehničara / prihod kompanije</TableCell>
                                <TableCell align="right">Ukupan Prihod tehničara / ukupan prihod kompanije</TableCell>
                            </TableRow>                                 
                            }
                            {type === 3 &&
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell>Prihod osiguravajuće kuće / prihod kompanije</TableCell>
                                <TableCell>Prihod osiguravajuće kuće / prihod kompanije</TableCell>
                                <TableCell>Prihod osiguravajuće kuće / prihod kompanije</TableCell>
                                <TableCell>Prihod osiguravajuće kuće / prihod kompanije</TableCell>
                                <TableCell>Prihod osiguravajuće kuće / prihod kompanije</TableCell>
                                <TableCell>Prihod osiguravajuće kuće / prihod kompanije</TableCell>
                                <TableCell>Prihod osiguravajuće kuće / prihod kompanije</TableCell>
                                <TableCell>Prihod osiguravajuće kuće / prihod kompanije</TableCell>
                                <TableCell>Prihod osiguravajuće kuće / prihod kompanije</TableCell>
                                <TableCell>Prihod osiguravajuće kuće / prihod kompanije</TableCell>
                                <TableCell>Prihod osiguravajuće kuće / prihod kompanije</TableCell>
                                <TableCell>Prihod osiguravajuće kuće / prihod kompanije</TableCell>
                                <TableCell align="right">Ukupan Prihod osiguravajuće kuće / ukupan prihod kompanije</TableCell>
                            </TableRow>                               
                            }
					</TableHead>
					<TableBody>
						{collection.map(({firstName, lastName, januaryIncome, januaryCompanyIncome, februaryIncome, februaryCompanyIncome, marchIncome, marchCompanyIncome, aprilIncome, aprilCompanyIncome, mayIncome, mayCompanyIncome, juneIncome, juneCompanyIncome, julyIncome, julyCompanyIncome, augustIncome, augustCompanyIncome, septemberIncome, septemberCompanyIncome, octoberIncome, octoberCompanyIncome, novemberIncome, novemberCompanyIncome, decemberIncome, decemberCompanyIncome, totalIncome, totalCompanyIncome }, index) => {
                                const incomeColors = getWorkerReportsColor([
                                    { month: 1, value: januaryIncome },
                                    { month: 2, value: februaryIncome},
                                    { month: 3, value: marchIncome},
                                    { month: 4, value: aprilIncome},
                                    { month: 5, value: mayIncome},
                                    { month: 6, value: juneIncome},
                                    { month: 7, value: julyIncome},
                                    { month: 8, value: augustIncome},
                                    { month: 9, value: septemberIncome},
                                    { month: 10, value: octoberIncome},
                                    { month: 11, value: novemberIncome},
                                    { month: 12, value: decemberIncome}
                                ]);

                                return (
                                    <TableRow hover key={index} className={tableRow}>
                                        <TableCell>{firstName} {lastName}</TableCell>
                                        <TableCell style={{ backgroundColor: `${incomeColors[0].color}` }}>{roundNumber(januaryIncome)} / {roundNumber(januaryCompanyIncome)}</TableCell>
                                        <TableCell style={{ backgroundColor: `${incomeColors[1].color}` }}>{roundNumber(februaryIncome)} / {roundNumber(februaryCompanyIncome)}</TableCell>
                                        <TableCell style={{ backgroundColor: `${incomeColors[2].color}` }}>{roundNumber(marchIncome)} / {roundNumber(marchCompanyIncome)}</TableCell>
                                        <TableCell style={{ backgroundColor: `${incomeColors[3].color}` }}>{roundNumber(aprilIncome)} / {roundNumber(aprilCompanyIncome)}</TableCell>
                                        <TableCell style={{ backgroundColor: `${incomeColors[4].color}` }}>{roundNumber(mayIncome)} / {roundNumber(mayCompanyIncome)}</TableCell>
                                        <TableCell style={{ backgroundColor: `${incomeColors[5].color}` }}>{roundNumber(juneIncome)} / {roundNumber(juneCompanyIncome)}</TableCell>
                                        <TableCell style={{ backgroundColor: `${incomeColors[6].color}` }}>{roundNumber(julyIncome)} / {roundNumber(julyCompanyIncome)}</TableCell>
                                        <TableCell style={{ backgroundColor: `${incomeColors[7].color}` }}>{roundNumber(augustIncome)} / {roundNumber(augustCompanyIncome)}</TableCell>
                                        <TableCell style={{ backgroundColor: `${incomeColors[8].color}` }}>{roundNumber(septemberIncome)} / {roundNumber(septemberCompanyIncome)}</TableCell>
                                        <TableCell style={{ backgroundColor: `${incomeColors[9].color}` }}>{roundNumber(octoberIncome)} / {roundNumber(octoberCompanyIncome)}</TableCell>
                                        <TableCell style={{ backgroundColor: `${incomeColors[10].color}` }}>{roundNumber(novemberIncome)} / {roundNumber(novemberCompanyIncome)}</TableCell>
                                        <TableCell style={{ backgroundColor: `${incomeColors[11].color}` }}>{roundNumber(decemberIncome)} / {roundNumber(decemberCompanyIncome)}</TableCell>
                                        <TableCell align="right">{roundNumber(totalIncome)} / {roundNumber(totalCompanyIncome)}</TableCell>
                                    </TableRow>
                                )
                            }
						)}
					</TableBody>
					<TablePagination
						page={page}
						rowsPerPage={rowsPerPage}
						count={totalCount}
						updatePagination={updateWorkerReportsPagination}
					/>
				</Table>
			</Paper>
		);
}

WorkerReportsTable.propTypes = {
    workerReports: PropTypes.object,
    type: PropTypes.number
}

const mapStateToProps = (state) => ({
    workerReports: state.workerReports
});

export default connect(mapStateToProps)(WorkerReportsTable);
